export default __webpack_public_path__ + "static/kb_2_6-fc55f8ca47c826ab0473933ff996b768.jpeg";